/**
 * It validates the email field of a form.
 * @param formValues - The values of the form.
 * @returns An object with the errors.
 */
export const emailValidations = (formValues) => {
  const errors = {};

  // Email
  if (!formValues.email.trim()) {
    errors.email = "El correo electrónico es obligatorio";
  }

  if (formValues.email && !/\S+@\S+\.\S+/.test(formValues.email)) {
    errors.email = "El correo electrónico no es válido";
  }

  if (formValues.email.length > 120) {
    errors.email = "El correo electrónico debe contener máximo 120 caracteres";
  }

  return errors;
};

/**
 * It validates the password and password confirmation fields of a form.
 * @param formValues - The values of the form
 * @returns An object with the errors.
 */
export const passwordValidations = (formValues) => {
  const errors = {};

  if (!formValues.password.trim()) {
    errors.password = "La contraseña es obligatoria";
  }

  if (formValues.password && formValues.password.length < 6) {
    errors.password = "La contraseña debe contener mínimo 6 caracteres";
  }

  // Password confirmation
  if (formValues.hasOwnProperty("password2") && !formValues.password2.trim()) {
    errors.password2 = "La confirmación de contraseña es obligatoria";
  }

  if (
    formValues.hasOwnProperty("password2") &&
    formValues.password !== formValues.password2
  ) {
    errors.password = "Las contraseñas no coinciden";
  }

  return errors;
};
